import { AbstractStepController, AppServerAPI, ContextChange, DialogService, FlowStepHandleResult, HandleResultType, StepControl, StepControlType, WizardServiceLocator } from '@sdbn/common';

import { LogContainer, TerminalContextConstants } from '@sdbn/tmc-common';
import { firstValueFrom } from 'rxjs';
import { YardPropertiesService } from '../../yard-properties.service';

export class CheckRoutingExistsResult {
  routingExists: boolean;
  constructor(result: Partial<CheckRoutingExistsResult>) {
    this.routingExists = result.routingExists === true;
  }
}
export class TransportRegistrationOptionsController extends AbstractStepController {

  private dialogService: DialogService;
  private yardPropertiesService: YardPropertiesService;
  private nextControl = new StepControl();

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector!.get(DialogService);
    this.yardPropertiesService = WizardServiceLocator.injector!.get(YardPropertiesService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.transportOptionsValidityState) {
      this.nextControl.disabled = !contextChange.value;
    }
    if (contextChange.key === TerminalContextConstants.skipTransportOptionSelection) {
      this.navigateToNextProcessStep();
    }
    if (contextChange.key === TerminalContextConstants.transportOptionsAutoSelect && contextChange.value === true) {
      this.navigateToNextProcessStep();
    }
  }

  onRegisterToDashboardContext() {

  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('options started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });

  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const previousControl = new StepControl();
    previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
    previousControl.type = StepControlType.BUTTON_STROKED;
    previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
    previousControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.previous();
    };
    controls.push(previousControl);

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    this.nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';;
    this.nextControl.type = StepControlType.BUTTON;
    this.nextControl.iconAfterCss = 'fa-thin fa-angle-right';
    this.nextControl.controlAction = () => {
      this.navigateToNextProcessStep();
    };
    controls.push(this.nextControl);

    return controls;
  }

  private navigateToNextProcessStep() {
    this.wizardComponent.stopInactivityMonitoring();
    if (this.yardPropertiesService.isChooseTargetStationForTransportsWithoutRoutingActive()) {
       this.checkRoutingExists().then(routingExists => {
      if (!routingExists) {
        this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.noRouteExistsProcessStep);
      } else {
        if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep) {
          this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep);
        } else {
          this.wizardComponent.next();
        }
      }
    });
    } else {
      if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep) {
          this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep);
        } else {
          this.wizardComponent.next();
        }
    }
   
  }


  private async checkRoutingExists() {
    const appServerAPI = WizardServiceLocator.injector!.get(AppServerAPI);

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    
    const selectedOptions = {
      selectedOptions: this.dashboardContext.getContextValue(TerminalContextConstants.selectedOptions)
    };
    const result = await firstValueFrom(appServerAPI.execute<CheckRoutingExistsResult>(`/terminal/registration/checkRoutingExists`, selectedOptions));

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);

    return result.routingExists;
  }
}
